module.exports = __webpack_public_path__ + "static/media/2.479fe268.mp4";